import paymentInstance from '../../instance'
import paymentModalLoginInstance from '../../modalLoginInstance'

const deleteTerminalPaymentSession = (terminalId, sessionId, hasModalLogin) => {
	return (hasModalLogin ? paymentModalLoginInstance : paymentInstance).delete(`/terminals/${terminalId}/paymentSessions/${sessionId}`)
}
export default deleteTerminalPaymentSession
